export default (loader) => {
    // eslint-disable-next-line
    (function (app) {
        if (app.strix && app.strix.saute) {
            return false;
        }
        loader(app);
    }(window));
};
